export interface ICrossService {
  id: number;
  img: string;
  name: string;
  shortName: string;
  steamAppId: number;
}
